// The shared admin pieces every board uses (stage 5). Screen builders import from here and add none of
// their own colours: every colour is a token in styles/tokens.css, every rule in styles/admin.css.
export { PageHeader, Crumbs, Card, InfoNote, Button, ButtonLink } from './Page.jsx'
export { Chip, Chips, Dot, ProductTag, StatusPill, Tabs, Flash, Loading, EmptyState, Problem } from './Bits.jsx'
export { Table } from './Table.jsx'
export { ConfirmPanel, Dialog } from './Dialog.jsx'
export { Field, TextInput, TextArea, Select, SearchBox, Checkbox, Switch, Options, SourceChoice, GRANT_SOURCES } from './Form.jsx'
export { DateField, DayField, TimeField, timeOptions } from './DateField.jsx'
export { ViewAsButton } from './ViewAsButton.jsx'
export { useLoad, useAction } from './useLoad.js'
export { toCsv, downloadCsv, csvDate, csvDateTime, csvFileName } from './csv.js'
export {
  plural, ukDate, ukDateLong, ukDateTime, ukDateShort, whenAgo, todayInUk, ukDayOf, ukToIso, ukEndOfDay, addDays,
  productDot, statusTone, time, dayMonth, shortDate, longDate,
} from './format.js'
export { useAdmin } from '../shell/context.jsx'
export { adminPath, ROLE_NAMES } from '../shell/routes.js'
